import { useEffect } from 'react';
import styles from './SpeakerModal.module.css';

export default function SpeakerModal({ speaker, onClose }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!speaker) return null;

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Cerrar"
        >
          ×
        </button>
        <div className={styles.content}>
          <div className={styles.photoWrapper}>
            <div
              className={styles.photo}
              style={speaker.photo ? { backgroundImage: `url(${speaker.photo})` } : {}}
            />
          </div>
          <h2 id="modal-title" className={styles.name}>{speaker.nombre}</h2>
          {(speaker.titulo || speaker.especialidad || speaker.bio) && (
            <ul className={styles.infoList}>
              {speaker.titulo && (
                <li className={styles.infoItem}><span className={styles.titulo}>{speaker.titulo}</span></li>
              )}
              {speaker.especialidad && (
                <li className={styles.infoItem}><span className={styles.especialidad}>{speaker.especialidad}</span></li>
              )}
              {speaker.bio && (() => {
                let parts = speaker.bio.split(/\. (?=[A-Z])/).filter(Boolean)
                  .map(p => p.trim().endsWith('.') ? p.trim() : p.trim() + '.');
                const merged = [];
                for (let i = 0; i < parts.length; i++) {
                  if (parts[i].startsWith('Director de posgrado') && i + 1 < parts.length) {
                    merged.push(parts[i] + ' ' + parts[i + 1]);
                    i++;
                  } else {
                    merged.push(parts[i]);
                  }
                }
                return merged.map((part, i) => (
                  <li key={i} className={styles.infoItem}><span className={styles.bio}>{part}</span></li>
                ));
              })()}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
